import { BoxFC, BoxFR } from "components/BoxCustom";
import React, { useMemo } from "react";
import useClientToday from "./useClientToday"
import { Box, Divider, IconButton, Typography, useMediaQuery } from "@mui/material";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import { scheduleJobColumns, todayColumns } from "./columns";
import { blue } from "@mui/material/colors";
import closingColor from "utils/closingColor";
import { calculateRowClosingColor } from "utils";
import JobOrderImageDialog from "./JobOrderImageDialog";
import { RefreshRounded } from "resource/muiImport";
import CheckupRecordDialog from "pages/menu7/CheckupRecord/CheckupRecordDialog";
import DriverAttendImageDialog from "pages/Menu1/DriverAttend/DriverAttendImageDialog";

const ClientToday = () => {
  const { state, fn } = useClientToday();
  const { todayData, scheduleData, selectedJobOrdId, mtChkChkId, selectedDrvAttnId } = state;

  const w800 = useMediaQuery('(min-width:800px)');

  const columns = useMemo(() => todayColumns(fn.handleImageClick, fn.handleLocationClick, fn.handleCheckupClick, fn.handleDriverClick), [fn]);
  const scheduleJobColumnsMemo = useMemo(() => scheduleJobColumns(fn.handleImageClick), [fn]);
  return (
    <BoxFC mx={2} height="100%" sx={{
      "& .MuiDataGrid-columnHeaders": { backgroundColor: blue[100] }
    }}>
      <BoxFR>
        <Typography variant="h5">Today ({todayData.length})</Typography>
        <IconButton sx={{ p: 0 }} onClick={fn.getData}>
          <RefreshRounded color="primary" />
        </IconButton>
      </BoxFR>
      <Box width="100%" flex={1} sx={closingColor}>
        <DataGridCellExpand
          density={w800 ? "standard" : "compact"}
          hideFooter
          rows={todayData}
          columns={columns}
          getRowClassName={calculateRowClosingColor} />
      </Box>
      <Divider />
      <Typography variant="h5" mt={2}>Schedule Jobs ({scheduleData.length})</Typography>
      <Box width="100%" flex={1} sx={closingColor}>
        <DataGridCellExpand

          density={w800 ? "standard" : "compact"}
          hideFooter
          rows={scheduleData}
          columns={scheduleJobColumnsMemo}
          getRowClassName={calculateRowClosingColor} />
      </Box>
      <JobOrderImageDialog
        dialogOpen={state.dialogImageOpen}
        setDialogOpen={fn.setDialogImageOpen}
        selectedId={selectedJobOrdId}
      /> 
      <CheckupRecordDialog
        selectedId={mtChkChkId}
        dialogOpen={state.dialogCheckupRecordOpen}
        setDialogOpen={fn.setDialogCheckupRecordOpen}
        lastFilter={null}
        onFinish={null}
        isReadOnly={true} />
      <DriverAttendImageDialog
        selectedDrvAttnId={selectedDrvAttnId}
        dialogOpen={state.dialogDriverAttendOpen}
        setDialogOpen={fn.setDialogDriverAttendOpen}
        isReadOnly={true} />
    </BoxFC>
  )
}

export default ClientToday